// extracted by mini-css-extract-plugin
export var contactContainer = "contact-module--contact-container--tSKVY";
export var contactText = "contact-module--contact-text--Lqrd9";
export var contactLabelContainer = "contact-module--contact-label-container--ZnmHe";
export var contactLabel = "contact-module--contact-label--6vUMU";
export var contactLabelSkills = "contact-module--contact-label-skills--2w4Gu";
export var contactLabelTools = "contact-module--contact-label-tools--h8JWR";